import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import TopBar from '../../../components/TopBar';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import RefundForm from '../../refunds/components/RefundForm';
import DetailsPageActionButtons from '../components/DraftDetailsPageActions';
import { useGetRefundHandler } from '../../refunds/dataHandlers/getRefundHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function DraftsRefundDetailsPage() {
  useDocumentTitle('Refund Details');
  const { document_id } = useParams();
  const navigate = useNavigate();

  const { refund, isLoading } = useGetRefundHandler(document_id);
  if (isLoading || !refund) {
    return <DocumentSkeletonForm />;
  }

  const handleBack = () => {
    navigate('/drafts?tab=refunds');
  };

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box sx={{ pb: 4 }}>
        <TopBar title="Refund Details" subTitle={refund?.document_id}>
          <DetailsPageActionButtons onBack={handleBack} />
        </TopBar>
      </Box>
      <RefundForm onSubmit={() => {}} onCancel={() => {}} initialData={refund} readOnly={true} />
    </Stack>
  );
}
